@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.root {
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 20px;

  @include for-desktop-only {
    padding-bottom: 20px;
  }
}

.checkboxBox {
  display: flex;
  align-items: center;
  height: 100%;
}

.buttons {
  display: flex;
  align-items: center;
  gap: 10px;
  align-self: stretch;
}

.connectSocial {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
}

.list {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow-y: auto;
}
